
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import React from "react";
import ProjectLookupSelect from './ProjectLookupSelect';

const styles = theme => ({
  chip: {
    margin: theme.spacing(1),
    minWidth: '200px !important',
  },
});

class ProjectLookup extends React.Component {
  
  render() {
    const { selectedProject } = this.props;
    
    return (
      <div className={selectedProject ? "" : "full-width"}>
        {!selectedProject &&
          <ProjectLookupSelect onProjectSelected={(project) => this.props.onProjectSelected(project)} />
        }
        {!!selectedProject &&
              <Chip
              onDelete={() => this.props.onProjectSelected(null)}
              className="chip"
              label={selectedProject.name}
              variant="outlined"
            />
        }
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(ProjectLookup);
